import React from 'react'
import { capitalizeWords, dateTimeFormat } from '../../../utils/HelperFuncitons'

function RidesDetailModal({ rideDetail, modalId, activeTab, rideStatus, hireRequestStatus, restaurantOrderStatus }) {
    console.log("rideDetails",rideDetail)
  const tableData = (activeTab === "rides" || activeTab === "packageDelivery") ? [
    { title: "Id", value: rideDetail?.id },
    { title: "Customer", value: `${rideDetail?.user?.firstName ? capitalizeWords(rideDetail?.user?.firstName) : ""} ${rideDetail?.user?.lastName ? capitalizeWords(rideDetail?.user?.lastName) : ""}` },
    ...(activeTab === "packageDelivery" ? [{ title: "Receiver", value: `${rideDetail?.receiverName ? capitalizeWords(rideDetail?.receiverName) : ""}` }] : []),
    { title: "Driver", value: rideDetail?.bookingDetail?.partnerUser?.partnerUserDetails?.[0]?.name ? rideDetail?.bookingDetail?.partnerUser?.partnerUserDetails?.[0]?.name : "-" },
    { title: "PickUp", value: rideDetail?.pickup ? rideDetail?.pickup : "-" },
    { title: "DropOff", value: rideDetail?.dropOff ? rideDetail?.dropOff : "-" },
    { title: "Fare", value: rideDetail?.charges ? rideDetail?.charges : "-" },
    { title: "Payment Mode", value: rideDetail?.paymentMode ? rideDetail?.paymentMode : "-" },
    { title: "Pickup Time", value: rideDetail?.bookingDetail?.time ? dateTimeFormat(Number(rideDetail?.bookingDetail?.time)) : "-" },
    { title: "DropOff Time", value: rideDetail?.bookingDetail?.dropOffTime && rideDetail?.bookingDetail?.status === "completed" ? dateTimeFormat(Number(rideDetail?.bookingDetail?.dropOffTime)) : "-" },
    { title: "Total Time", value: rideDetail?.duration ? rideDetail?.duration : "-" },
    { title: "Total KM", value: rideDetail?.distance ? rideDetail?.distance : "-" },
    { title: "Status", value: rideStatus(rideDetail?.isCancelled ? "cancelled" : rideDetail?.bookingDetail?.status, rideDetail?.bookingDetail?.role) },
  ]
    : activeTab === "hire" ? [
      { title: "Id", value: rideDetail?.id },
      { title: "Customer", value: `${rideDetail?.user?.firstName ? capitalizeWords(rideDetail?.user?.firstName) : ""} ${rideDetail?.user?.lastName ? capitalizeWords(rideDetail?.user?.lastName) : ""}` },
      { title: "Vendor", value: rideDetail?.bookingDetailsRental?.partnerUser?.partnerUserDetails?.[0]?.name ? rideDetail?.bookingDetailsRental?.partnerUser?.partnerUserDetails?.[0]?.name : "-" },
      { title: "PickUp", value: rideDetail?.pickup ? rideDetail?.pickup : "-" },
      { title: "DropOff", value: rideDetail?.dropOff ? rideDetail?.dropOff : "-" },
      { title: "Fare", value: rideDetail?.charges ? rideDetail?.charges : "-" },
      { title: "Payment Mode", value: rideDetail?.paymentMode ? rideDetail?.paymentMode : "-" },
      { title: "Pickup Time", value: rideDetail?.pickUpTime ? dateTimeFormat(rideDetail?.pickUpTime) : "-" },
      { title: "DropOff Time", value: rideDetail?.dropOffTime ? dateTimeFormat(rideDetail?.dropOffTime) : "-" },
      { title: "Total Time", value: rideDetail?.duration ? rideDetail?.duration : "-" },
      { title: "Status", value: hireRequestStatus(rideDetail?.isCancelled ? "cancelled" : rideDetail?.bookingDetailsRental?.status, (rideDetail?.bookingDetailsRental?.role ?? "user")) },
    ]
    : activeTab === "busOperator" ? [
      { title: "Id", value: rideDetail?.id },
        { title: "Customer", value: `${rideDetail?.user?.firstName ? capitalizeWords(rideDetail?.user?.firstName) : ""} ${rideDetail?.user?.lastName ? capitalizeWords(rideDetail?.user?.lastName) : ""}` },
         { title: "Bus Name", value: rideDetail?.busScheduleFare?.busSchedule?.busDetail?.name ? rideDetail?.busScheduleFare?.busSchedule?.busDetail?.name :"-" },
          {
          title: "Bus Details",
          value: rideDetail?.busScheduleFare?.busSchedule?.busDetail ? (
            <div style={{ overflowX: "auto", marginTop: "10px" }}>
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  textAlign: "left",
                  border: "1px solid #ddd",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>BusType</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Name</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>RegistrationNo</th>
                  </tr>
                </thead>
                <tbody>      
                    <tr >
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{rideDetail?.busScheduleFare?.busSchedule?.busDetail?.busType}</td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{rideDetail?.busScheduleFare?.busSchedule?.busDetail?.name}</td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{rideDetail?.busScheduleFare?.busSchedule?.busDetail?.registrationNo}</td>
                    </tr>             
                </tbody>
              </table>
            </div>
          ) : (
            "-"
          ),
        },
        {   title: "Travel Date",   value: rideDetail?.travelDate   ? new Date(rideDetail.travelDate).toISOString().split('T')[0]   : "-" },
        { title: "PickUp", value: rideDetail?.busScheduleFare?.fromStopName ? rideDetail?.busScheduleFare?.fromStopName : "-" },
        { title: "DropOff", value: rideDetail?.busScheduleFare?.toStopName ? rideDetail?.busScheduleFare?.toStopName : "-" },
        { title: "No Of Passenger", value: rideDetail?.noOfPassenger ? rideDetail?.noOfPassenger : "-" },
        {
          title: "Passenger",
          value: rideDetail?.busTicketPassengers?.length ? (
            <div style={{ overflowX: "auto", marginTop: "10px" }}>
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  textAlign: "left",
                  border: "1px solid #ddd",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>BusSeatId</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Name</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Gender</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Age</th>
                  </tr>
                </thead>
                <tbody>
                  {rideDetail.busTicketPassengers.map((passenger, index) => (
                    <tr key={index}>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{passenger.busSeatId}</td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{passenger.name}</td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{passenger.gender}</td>
                      <td style={{ padding: "8px", border: "1px solid #ddd" }}>{passenger.age}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            "-"
          ),
        }
        ,
        { title: "Fare", value: rideDetail?.totalAmount ? rideDetail?.totalAmount : "-" },
        { title: "Payment Mode", value: rideDetail?.paymentMode ? rideDetail?.paymentMode : "-" },
      // { title: "Pickup Time", value: rideDetail?.pickUpTime ? dateTimeFormat(rideDetail?.pickUpTime) : "-" },
      // { title: "DropOff Time", value: rideDetail?.dropOffTime ? dateTimeFormat(rideDetail?.dropOffTime) : "-" },
      // { title: "Total Time", value: rideDetail?.duration ? rideDetail?.duration : "-" },
      { title: "Status", value: hireRequestStatus(rideDetail?.isCancelled ? "cancelled" : rideDetail?.bookingDetailsRental?.status, (rideDetail?.bookingDetailsRental?.role ?? "user")) },
    ]
      : [
        { title: "Id", value: rideDetail?.id },
        { title: "Customer", value: `${rideDetail?.user?.firstName ? capitalizeWords(rideDetail?.user?.firstName) : ""} ${rideDetail?.user?.lastName ? capitalizeWords(rideDetail?.user?.lastName) : ""}` },
        { title: "Restaurant", value: rideDetail?.restaurant?.name ? capitalizeWords(rideDetail?.restaurant?.name) : "-" },
        {
          title: "Food Items", value: (
            rideDetail?.foodOrderItems?.map(el => <>
              <tr>{el?.menuItem?.name}</tr>
            </>)
          )
        },
        { title: "Restaurant Address", value: rideDetail?.restaurant?.address ? capitalizeWords(rideDetail?.restaurant?.address) : "-" },
        { title: "Delivery Partner", value: rideDetail?.driverDetails?.name ? capitalizeWords(rideDetail?.driverDetails?.name) : "-" },
        { title: "Ride Booking Id", value: rideDetail?.driverDetails?.rideBookingId || "-" },
        { title: "Delivery Address", value: rideDetail?.deliveryAddress?.address ?? "-" },
        { title: "Fare", value: rideDetail?.totalAmount ? rideDetail?.totalAmount : "-" },
        { title: "Driver charge", value: rideDetail?.driverDetails?.driverCharges },
        { title: "Payment Mode", value: rideDetail?.paymentMode ? rideDetail?.paymentMode : "-" },
        { title: "Date", value: rideDetail?.createdAt ? dateTimeFormat(rideDetail?.createdAt) : "-" },
        { title: "Status", value: restaurantOrderStatus(rideDetail?.status, rideDetail?.cancelledBy) },
      ]

  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-body ">
            <div className=' d-flex justify-content-between'>
              <h2 >
                Ride Details
              </h2>
              <div className=' border-0'>

                <button type="button" className="btn-close block-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
            </div>
            <table className='table'>
              <tbody>
                {tableData.map((el, index) => <tr key={index}>
                  <td>{el.title}</td>
                  <td>{el.value}</td>
                </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RidesDetailModal